<template>
  <div>
    <img src="../assets/newsbanner.jpg" class="img-fluid w-100" alt="newsbanner">
    <section class="feature-area">
      <div class="mbx">
        <div class="container">
          <div class="row">
            <div class="col-lg-9">
              <div class="nytit pull-left">新闻中心</div>
              <menu class="menu pull-left" id="menu">
                <div class="pull-left paddingleft15"><a href="javascript:void(0);" class="underline text66" :class="{'cur':nav_status_1}" @click="changeTab(0)">企业动态</a></div>
                <div class="pull-left paddingleft15"><a href="javascript:void(0);" class="underline text66" :class="{'cur':nav_status_2}" @click="changeTab(1)">代理品牌动态</a></div>
                <div class="pull-left paddingleft15"><a href="javascript:void(0);" class="underline text66" :class="{'cur':nav_status_3}" @click="changeTab(2)">行业资讯</a></div>
              </menu>
            </div>
            <div class="col-lg-3">
              <div class="mbxwrap">
                <router-link to="/" class="underline">首页</router-link> <span>/</span>
                <router-link to="/news" class="underline">新闻中心</router-link> <span>/</span>
                <em>{{breadCrumbName}}</em>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
    <div class="nycon">

      <div class="container">
        <div class="news_show">
          <div class="nstit">
            <h1>{{news_details.title}}</h1>
            <div class="date">
              <span>时间：{{news_details.updateTime}}</span>
              <span>来源：北京泽浩天</span>
              <span>浏览量：{{news_details.pageView}}</span>
            </div>
          </div>
          <div class="nstxt" style="color: black">
            <div v-html="news_details.newsContent"></div>
          </div>
<!--          &nbsp;-->
          <div class="prevnext clearfix">
            <div class="pnwrap pull-left">
              <a href="javascript:void(0);" class="underline" @click="getNewsDetailsPreOrNext(news_pre)">上一篇：{{news_pre.title}}</a>
              <a href="javascript:void(0);" class="underline" @click="getNewsDetailsPreOrNext(news_next)">下一篇：{{news_next.title}}</a>
            </div>
            <router-link to="/news" class="return pull-right underline">
              返回列表
            </router-link>
          </div>
          <div class="xgnews clearfix">
            <div class="pstit">
              <span>相关新闻</span>
            </div>
            <div v-if="news_related_list != null || news_related_list != '' || news_related_list != undefined">
              <ul class="pull-left">
                <li v-for="(list, index) in news_related_list" v-if="index%2 == 0"><a href="javascript:void(0);" class="myoverflow underline" :title="list.title" @click="getNewsDetailsPreOrNext(list)">{{list.title}}</a><span>[ {{list.updateTime}} ]</span></li>
              </ul>
              <ul class="pull-right">
                <li v-for="(list, index) in news_related_list" v-if="index%2 == 1"><a href="javascript:void(0);" class="myoverflow underline" :title="list.title" @click="getNewsDetailsPreOrNext(list)">{{list.title}}</a><span>[ {{list.updateTime}} ]</span></li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data () {
      return {
        news: JSON.parse(this.$_storage.getLocalStore("news")),
        nav_status_1: JSON.parse(this.$_storage.getLocalStore("index")) == null ? true : JSON.parse(this.$_storage.getLocalStore("index")) == 0,
        nav_status_2: JSON.parse(this.$_storage.getLocalStore("index")) == null ? false : JSON.parse(this.$_storage.getLocalStore("index")) == 1,
        nav_status_3: JSON.parse(this.$_storage.getLocalStore("index")) == null ? false : JSON.parse(this.$_storage.getLocalStore("index")) == 2,
        breadCrumbName: '',
        news_details: '',
        news_pre: '',
        news_next: '',
        news_related_list: [],
        index: JSON.parse(this.$_storage.getLocalStore("index")) == null ? 0 : JSON.parse(this.$_storage.getLocalStore("index")),
      }
    },
    methods:{
      getNewsDetails(id){
        const vm = this;
        vm.$_axios({
          method: 'post',
          url: '/mapis/news/getNewsDetails',
          params: {
            newsId: id
          },
          needLogin: false,
        }).then((response) => {
          if (response.status === 200) {
            const responseData = response.data.data;
            vm.news_details = responseData;
            vm.getNewsPreAndNext(vm.news_details.newsId);
          }
        });
      },
      getNewsPreAndNext(id){
        const vm = this;
        vm.$_axios({
          method: 'post',
          url: '/mapis/news/getNewsPreAndNext',
          params: {
            newsId: id
          },
          needLogin: false,
        }).then((response) => {
          if (response.status === 200) {
            const responseData = response.data.data;
            vm.news_pre = responseData.newsPre;
            vm.news_next = responseData.newsNext;
          }
        });
      },
      getNewsDetailsPreOrNext(news){
        const vm = this;
        if(news.title == '无'){
          console.log('无:' + news)
          return;
        }
        this.$_storage.setLocalStore("news",news);
        vm.$router.push({name:'newsDetails'});
        vm.$router.replace('/refresh');
      },
      getRelatedNews(){
        const vm = this;
        vm.$_axios({
          method: 'post',
          url: '/mapis/news/getRelatedNews',
          data: {
            category: vm.news.category,
            id: vm.news.id
          },
          needLogin: false,
        }).then((response) => {
          if (response.status === 200) {
            const responseData = response.data.data;
            vm.news_related_list = responseData;
          }
        });
      },
      changeTab(index){
        const vm = this;
        if(0 == index){
          vm.$_storage.setLocalStore('index',0);
        }else if(1 == index){
          vm.$_storage.setLocalStore('index',1);
        }else if(2 == index){
          vm.$_storage.setLocalStore('index',2);
        }
        vm.$router.push({name:'news'});
      },
    },
    created() {
      var vm = this;
      console.log(vm.news)
      if(0 == vm.news.category){
        vm.nav_status_1 = true;
        vm.nav_status_2 = false;
        vm.nav_status_3 = false;
        vm.breadCrumbName = '企业动态';
      }else if(1 == vm.news.category){
        vm.nav_status_1 = false;
        vm.nav_status_2 = true;
        vm.nav_status_3 = false;
        vm.breadCrumbName = '代理品牌动态';
      }else if(2 == vm.news.category){
        vm.nav_status_1 = false;
        vm.nav_status_2 = false;
        vm.nav_status_3 = true;
        vm.breadCrumbName = '行业资讯';
      }
    },
    mounted() {
      var vm = this;
      vm.getNewsDetails(vm.news.id);
      vm.getRelatedNews();
      console.log(vm.index == null);

      // vm.getNews(0,1);
    }
  }
</script>




// WEBPACK FOOTER //
// NewsDetails.vue?5d8d3ab5